// extracted by mini-css-extract-plugin
export var cardIcon = "_6c-5";
export var cardIconUnframed = "_6c-9";
export var checkboxCard = "_6c-0";
export var checkboxCardSelected = "_6c-4";
export var disabled = "_6c-2";
export var interactive = "_6c-1";
export var outerBorder = "_6c-3";
export var spacerMedium = "_6c-8";
export var spacerSmall = "_6c-7";
export var spacerXsmall = "_6c-6";